import { render, staticRenderFns } from "./DashboardVentasRankingCenter.vue?vue&type=template&id=5801ace4&scoped=true&lang=pug"
import script from "./DashboardVentasRankingCenter.vue?vue&type=script&lang=js"
export * from "./DashboardVentasRankingCenter.vue?vue&type=script&lang=js"
import style0 from "./DashboardVentasRankingCenter.vue?vue&type=style&index=0&id=5801ace4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5801ace4",
  null
  
)

export default component.exports